import { ChangeEvent, useCallback, useState } from 'react'
import { Form } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import classNames from 'classnames'

import { WidgetProps } from '@rjsf/utils'

import { SelectDropdown, SelectOption } from '../../components/SelectDropdown/SelectDropdown'

import './UpdateExternalContactForm.scss'

export const CustomDateWidget = (props: WidgetProps) => {
  const formatDateLocal = (date: Date): string => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }
  const parseDateLocal = (dateString: string): Date | null => {
    const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/)
    if (!match) {
      return null
    }
    const [, year, month, day] = match
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
    if (isNaN(date.getTime())) {
      return null
    }
    return date
  }

  const parseDate = useCallback(
    (value: string | null | undefined) => {
      if (!value) {
        return null
      }
      const date = parseDateLocal(value)
      if (!date) {
        return null
      }
      const formattedValue = formatDateLocal(date)
      if (formattedValue !== value) {
        props.onChange(formattedValue)
      }
      return date
    },
    [props],
  )

  const [selectedDate, setSelectedDate] = useState<Date | null>(() => parseDate(props.value))

  const handleChange = (newValue: Date | null) => {
    if (!newValue) {
      return
    }
    const formattedValue = formatDateLocal(newValue)
    props.onChange(formattedValue)
    setSelectedDate(newValue)
  }
  return (
    <DatePicker
      className='form-control react-datepicker-popper'
      wrapperClassName='w-100'
      selected={selectedDate}
      onChange={handleChange}
      todayButton='Today'
      placeholderText='Not set'
      portalId='root-portal'
    />
  )
}

export const CustomSelectWidget = (props: WidgetProps) => {
  const options =
    props.options.enumOptions?.map((enumOption, index) => ({
      id: `${index}`,
      label: enumOption.label,
    })) ?? []

  const handleOptionSelected = (option: SelectOption) => {
    if (!props.options.enumOptions) {
      return
    }
    const optionIndex = parseInt(option.id)
    props.onChange(props.options.enumOptions[optionIndex].value)
  }

  const getInitialSelectedOption = () => {
    if (!props.options.enumOptions) {
      return null
    }
    const optionIndex = props.options.enumOptions.findIndex((e) => e.value === props.value)
    if (optionIndex === -1) {
      return null
    }
    const option = props.options.enumOptions[optionIndex]
    return { id: `${optionIndex}`, label: option.label }
  }

  return (
    <SelectDropdown
      className={classNames('form-control', { 'disabled-contact-information-field border-0': props.disabled })}
      options={options}
      placeholder='Not set'
      initialSelectedOption={getInitialSelectedOption()}
      onOptionSelected={handleOptionSelected}
      disabled={props.disabled}
      hideArrows={props.disabled}
    />
  )
}

export const CustomCheckboxWidget = (props: WidgetProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChange(e.target.checked)
  }
  return (
    <div
      className={classNames('form-control border-0', {
        'disabled-contact-information-field': props.disabled,
      })}
    >
      <Form.Check
        className='d-flex contact-information-checkbox'
        type='checkbox'
        checked={props.value ?? false}
        onChange={handleChange}
        disabled={props.disabled}
      />
    </div>
  )
}
